<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/client">Clientes</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Novo cliente</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                        <a href="#info" role="tab" data-toggle="tab" class="nav-link active"> Dados Pessoais </a>
                    </li>
                    <li class="nav-item">
                        <button role="tab" data-toggle="tab" class="nav-link" :disabled="true">
                            Dados fiscais </button>
                    </li>
                    <li class="nav-item">
                        <button role="tab" data-toggle="tab" class="nav-link" :disabled="true">
                            Serviços </button>
                    </li>
                    <li class="nav-item">
                        <button role="tab" data-toggle="tab" class="nav-link" :disabled="true">
                            Acessos </button>
                    </li>
                    <li class="nav-item">
                        <button role="tab" data-toggle="tab" class="nav-link" :disabled="true">
                            Status </button>
                    </li>
                    <li class="nav-item">
                        <button role="tab" data-toggle="tab" class="nav-link" :disabled="true">
                            Arquivos </button>
                    </li>
                </ul>
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow mb-4">
                            <!-- Card Header - Dropdown -->
                            <div class="card-body">
                                <form @submit="save">
                                    <fieldset>
                                        <legend>Dados gerais</legend>
                                        <div class="row mt-2">
                                            <div class="col-xl-2 col-md-2 col-sm-12">
                                                <label for="">Matrícula</label>
                                                <div class="input-group mb-3">
                                                    <input type="text" class="form-control" placeholder="Ex: 1"
                                                        v-model="client.mat">
                                                </div>
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">CPF*</label>
                                                <div class="input-group mb-3">
                                                    <input type="text" class="form-control"
                                                        placeholder="Ex: xxx.xxx.xxx-xx" v-model="client.document"
                                                        v-mask="['###.###.###-##']">

                                                </div>
                                            </div>
                                            <div class="col-xl-6 col-md-6 col-sm-12">
                                                <label for="">Nome*</label>
                                                <input type="text" class="form-control"
                                                    placeholder="Ex: José da Silva Lima" v-model="client.name">
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">Data de nascimento</label>
                                                <input type="date" class="form-control" v-model="client.birthday">
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">Sexo</label>
                                                <multiselect v-model="gender_multiselect" :options="gender_options"
                                                    :custom-label="sexoWithLang" placeholder="Selecione uma opção"
                                                    :select-label="'Clique para selecionar'"
                                                    :deselect-label="'Clique para remover'" @select="handleSelect">

                                                    <template #noResult>
                                                        Nenhum sexo encontrado.
                                                    </template>
                                                </multiselect>
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">Telefone*</label>
                                                <input type="text" class="form-control" v-model="client.phone"
                                                    v-mask="['(##) ####-####', '(##) #####-####']"
                                                    placeholder="(xx)x.xxxx-xxxx">
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-xl-8 col-md-8 col-sm-12">
                                                <label for="">E-mail</label>
                                                <input type="text" class="form-control"
                                                    placeholder="Ex: usuario@dominio.com" v-model="client.email">
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">Nº CNH</label>
                                                <input type="text" class="form-control" v-model="client.cnh"
                                                    placeholder="Ex: xxxxx" v-mask="['###########']">
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">RG</label>
                                                <input type="text" class="form-control" v-model="client.rg"
                                                    placeholder="Ex: xxxxx">
                                            </div>
                                            <div class="col-xl-3 col-md-4 col-sm-12">
                                                <label for="">Órgão expeditor</label>
                                                <multiselect v-model="client.issuing_body"
                                                    :options="issuing_body_options" placeholder="Selecione uma opção"
                                                    :select-label="'Clique para selecionar'"
                                                    :deselect-label="'Clique para remover'">
                                                    <template #noResult>
                                                        Nenhum órgão expeditor encontrado.
                                                    </template>
                                                </multiselect>
                                            </div>
                                            <div class="col-xl-3 col-md-4 col-sm-12">
                                                <label for="">UF Órgão expeditor</label>
                                                <multiselect v-model="client.uf_issuing_body"
                                                    :options="uf_issuing_body_options" placeholder="Selecione uma opção"
                                                    :select-label="'Clique para selecionar'"
                                                    :deselect-label="'Clique para remover'">
                                                    <template #noResult>
                                                        Nenhum estado(UF) encontrado.
                                                    </template>
                                                </multiselect>
                                            </div>
                                            <div class="col-xl-2 col-md-2 col-sm-12">
                                                <label for="">Data Expedição</label>
                                                <input type="date" class="form-control" v-model="client.date_dispatch">
                                            </div>
                                        </div>
                                        <div class="row mt-2 mb-4">
                                            <div class="col-xl-6 col-md-6 col-sm-12">
                                                <label for="">Nome do pai</label>
                                                <input type="text" class="form-control" v-model="client.name_father"
                                                    placeholder="Ex: José Antônio da Silva">
                                            </div>
                                            <div class="col-xl-6 col-md-6 col-sm-12">
                                                <label for="">Nome da mãe</label>
                                                <input type="text" class="form-control" v-model="client.name_mother"
                                                    placeholder="Ex: Maria da Silva">
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-xl-3 col-md-3 col-sm-12">
                                                <label for="">Nº título e eleitor</label>
                                                <input type="text" class="form-control"
                                                    v-model="client.number_registration_voter" placeholder="Ex: xxxxx">
                                            </div>
                                            <div class="col-xl-3 col-md-3 col-sm-12">
                                                <label for="">Estado Civil</label>
                                                <multiselect v-model="client.status_civil"
                                                    :options="status_civil_options" placeholder="Selecione uma opção"
                                                    :select-label="'Clique para selecionar'">
                                                    <template #noResult>
                                                        Nenhum estado civil encontrado.
                                                    </template>
                                                </multiselect>
                                            </div>
                                            <div class="col-xl-3 col-md-3 col-sm-12">
                                                <label for="">PIS/PASEP</label>
                                                <input type="text" class="form-control" v-model="client.pis_pasep"
                                                    placeholder="Ex: xxxxx">
                                            </div>
                                            <div class="col-xl-3 col-md-3 col-sm-12">
                                                <label for="">Etnia</label>
                                                <multiselect v-model="client.ethnicity" :options="ethnicity_options"
                                                    placeholder="Selecione uma opção"
                                                    :select-label="'Clique para selecionar'">
                                                    <template #noResult>
                                                        Nenhuma etnia encontrada.
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-xl-6 col-md-6 col-sm-12">
                                                <label for="">Escolaridade</label>
                                                <multiselect v-model="client.education" :options="education_options"
                                                    placeholder="Selecione uma opção">
                                                </multiselect>
                                            </div>
                                            <div class="col-xl-6 col-md-6 col-sm-12">
                                                <label for="">Profissão</label>
                                                <input type="text" class="form-control" v-model="client.occupation"
                                                    placeholder="Ex: Engenheiro Elétrico">
                                            </div>
                                        </div>
                                    </fieldset>
                                    <fieldset class="mt-4">
                                        <legend>Endereço</legend>

                                        <div class="row mt-2">
                                            <div class="col-xl-3 col-md-3 col-sm-12">
                                                <label for="">CEP</label>

                                                <div class="input-group mb-3">
                                                    <input type="text" class="form-control" placeholder="Ex: xxxxx-xxx"
                                                        v-model="client.zipcode" v-mask="['#####-###']">
                                                    <div class="input-group-append">
                                                        <button class="btn btn-success" type="button" id="button-addon2"
                                                            @click="searchZipcode()"><i class="fa fa-search"></i>Buscar
                                                            CEP</button>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="col-xl-7 col-md-7 col-sm-12">
                                                <label for="">Endereço*</label>
                                                <input type="text" class="form-control" placeholder="Ex: Av. Paulista"
                                                    v-model="client.street">
                                            </div>
                                            <div class="col-xl-2 col-md-2 col-sm-12">
                                                <label for="">Nº</label>
                                                <input type="text" class="form-control" placeholder="Ex: 100"
                                                    v-model="client.number_street">
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-xl-12 col-md-12 col-sm-12">
                                                <label for="">Complemento</label>
                                                <input type="text" class="form-control" placeholder="Ex: Próximo à...."
                                                    v-model="client.complement">
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">Bairro</label>
                                                <input type="text" class="form-control" placeholder="Ex: Centro"
                                                    v-model="client.district">
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">Cidade</label>
                                                <input type="text" class="form-control" placeholder="Ex: São Paulo"
                                                    v-model="client.city">
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">UF</label>
                                                <input type="text" class="form-control" placeholder="Ex: SP"
                                                    v-model="client.uf">
                                            </div>
                                        </div>
                                    </fieldset>
                                    <fieldset>
                                        <legend>Observações</legend>
                                        <div class="row mb-4">
                                            <div class="col-lg-12 col-xs-12 col-sm-12">
                                                <editorText @update-text="updateObservation"
                                                    :modelValue="client.observation" placeholderSend="Sem observações"
                                                    ref="myChild">
                                                </editorText>
                                            </div>
                                        </div>
                                        <br>
                                    </fieldset>
                                    <br>
                                    <div class="row">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                    class="fa fa-save"></i> Cadastrar</button>
                                            <router-link to="/client" class="btn btn-danger ml-3"><i
                                                    class="fa fa-times"></i>
                                                Cancelar</router-link>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { loadZipcode } from '@/api-external';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import editorText from '../util/editor-text.vue';
import Multiselect from 'vue-multiselect'

export default {
    directives: { mask },
    components: { Loading, editorText, Multiselect },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            tab_active: true,
            searchCnpj: true,
            gender_options: [
                { type: 'm', value: 'Masculino' },
                { type: 'f', value: 'Feminino' },
                { type: 'o', value: 'Outros' },
            ],
            issuing_body_options: ['SSP', 'Cartório Civil', 'Polícia Federal', 'DETRAN'],
            uf_issuing_body_options: ['AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO', 'EX (Estrangeiro)'],
            status_civil_options: ['Casado (a) (Comunhão parcial)', 'Casado (a) (Comunhão total)', 'Separado (a)', 'Divorciado (a)', 'Desquitado (a)', 'Viúvo (a)', 'Casado (a) (Separação total de bens)', 'Solteiro (a)'],
            ethnicity_options: ['Branca', 'Preta', 'Parda', 'Amarela', 'Indígena'],
            education_options: ['Ensino Médio Incompleto', 'Ensino Médio Completo', 'Gradução Incompleta', 'Graduação Completa', 'Pós Graduação Completa', 'Pós Graduação Incompleta'],
            gender_multiselect: '',
            client: {
                mat: '',
                document: '',
                name: '',
                birthday: '',
                gender: '',
                phone: '',
                email: '',
                cnh: '',
                rg: '',
                issuing_body: '',
                uf_issuing_body: '',
                date_dispatch: '',
                name_father: '',
                name_mother: '',
                number_registration_voter: '',
                status_civil: '',
                pis_pasep: '',
                ethnicity: '',
                education: '',
                occupation: '',
                zipcode: '',
                street: '',
                number_street: '',
                complement: '',
                district: '',
                city: '',
                uf: '',
                observation: ''
            },
            enable_error_list: false,
            errors: []
        }
    },

    computed: {
        isDisabled: function () {
            return this.client.document != '' && this.client.name != '' && this.client.phone != '';
        }
    },
    mounted() {
        this.isLoading = false;
    },
    methods: {
        onCancel() { },
        searchZipcode() {
            this.isLoading = true;
            if (this.client.zipcode.length > 0) {
                let zipcode = this.client.zipcode.replace(/\D/g, '');
                loadZipcode(zipcode).then((response) => {
                    this.client.street = response.street;
                    this.client.district = response.neighborhood;
                    this.client.city = response.city;
                    this.client.uf = response.state;
                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                });
            } else {
                this.$notify({
                    title: "Informação",
                    text: "Informe um CEP válido",
                    type: 'info'
                });
            }
        },
        handleSelect(option) {
            this.client.gender = option.type;
        },
        sexoWithLang({ value }) {
            return value;
        },

        updateObservation(observation) {
            this.client.observation = observation;
        },
        save(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.post('/client', this.client)
                .then((response) => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Cliente cadastrado com sucesso!",
                        type: 'success'
                    });
                    this.client = {};
                    this.$router.push({
                        name: 'client_fiscal_edit',
                        params: { id: response.data.client.id }
                    });
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })

        }
    }
}
</script>

<style></style>